import { Pipe, PipeTransform } from '@angular/core';
import { Select } from '@ngxs/store';
import moment from 'moment';
import { Observable, of } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { LanguageType } from 'src/app/samwebDescription/samweb/settings/language-types';
import { SettingsState } from 'src/app/store/settings/settings.state';

@Pipe({
   name: 'toUTCMoment$',
})
export class ToUtcMomentPipe implements PipeTransform {
   @Select(SettingsState.getCurrentLanguage)
   private languageType$: Observable<LanguageType>;

   transform(value: string | Date): Observable<moment.Moment> {
      const value$: Observable<string | Date> = of(value);
      const moment$: Observable<moment.Moment> = this.languageType$.pipe(
         switchMap((lang) =>
            value$.pipe(
               tap(() => moment.locale(lang.angularTranslationKey)),
               map((date: string | Date) => moment.utc(date))
            )
         )
      );
      return moment$;
   }
}
